// src/components/PrivateRoute/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // <-- путь должен быть точным

export default function PrivateRoute({ allowedRoles, children }) {
  const { user } = useAuth();

  if (!user?.token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <p>У вас нет доступа к этой странице.</p>;
  }

  return children;
}
